import React, { FC, useMemo } from 'react';
import { TextField } from '@mui/material';
import { isNil } from 'lodash';
import { shortDate } from 'utilities';
import { StyledAutocomplete, StyledFormControl, StyledSkeleton } from './styles';
import { DateSelectorProps, MeasurementDate } from './types';

const DateSelector: FC<DateSelectorProps> = ({ options, onSelectMD }) => {
  const measurementDates = useMemo(() => {
    if (isNil(options)) {
      return [];
    }
    return options
      .map(
        option =>
          ({
            ...option,
            name: shortDate(option.name),
          }) as MeasurementDate
      )
      .filter(option => option.name)
  }, [options]);

  if (isNil(options)) {
    return <StyledSkeleton variant="text" width={150} height={50} />;
  }

  const handleOnChange = (_event: React.SyntheticEvent, selectedMd: MeasurementDate | null): void => {
    if (selectedMd) {
      onSelectMD(selectedMd.date);
    }
  };

  return (
    <StyledFormControl>
      <StyledAutocomplete
        id="date-selector"
        autoHighlight
        disableClearable={true}
        options={measurementDates}
        style={{ width: '100%' }}
        getOptionLabel={(option: MeasurementDate) => option.name}
        onChange={handleOnChange}
        renderInput={params => <TextField {...params} label="Select a measurement date" />}
      />
    </StyledFormControl>
  );
};

export default DateSelector;
